export const DrugInteractionAlert = {
  flow: 'x',
  gap: 'Z',
  padding: 'A',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',
  borderLeft: '4px solid red',

  AlertIcon: {
    extends: 'Icon',
    icon: 'alertTriangle',
    fontSize: 'B',
    color: 'red',
    flexShrink: '0'
  },

  Content: {
    flow: 'y',
    gap: 'Y',
    flex: '1',

    InteractionPair: {
      text: (el, s) => s.interactionPair || '',
      fontSize: 'Z',
      fontWeight: '700',
      color: 'inkText'
    },

    SeverityBadge: {
      tag: 'span',
      text: (el, s) => s.severity || '',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      alignSelf: 'flex-start',
      background: (el, s) => {
        const sv = s.severity
        if (sv === 'Major') return 'red.15'
        if (sv === 'Moderate') return 'amber.15'
        if (sv === 'Minor') return 'inkSurface'
        return 'inkSurface'
      },
      color: (el, s) => {
        const sv = s.severity
        if (sv === 'Major') return 'red'
        if (sv === 'Moderate') return 'amber'
        if (sv === 'Minor') return 'inkMuted'
        return 'inkMuted'
      }
    },

    Description: {
      text: (el, s) => s.description || '',
      fontSize: 'Z',
      color: 'inkMuted',
      lineHeight: '1.4'
    },

    Recommendation: {
      text: (el, s) => s.recommendation || '',
      fontSize: 'Z',
      color: 'inkText',
      fontWeight: '500',
      fontStyle: 'italic'
    }
  }
}
